// 配置 AWS 区域和 Cognito Identity Pool ID
const REGION = 'us-west-1';
const IDENTITY_POOL_ID = 'us-west-1:66834baf-e421-404c-998f-ca02e589842f';

AWS.config.region = REGION;
AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: IDENTITY_POOL_ID,
});

// 上传图片到 S3 的函数
function uploadImageToS3(blob, objectKey, isMobile = false) {
    // 将 base64 转换为二进制数据
    // var binaryData = atob(base64Image);
    // var arrayBuffer = new ArrayBuffer(binaryData.length);
    // var uint8Array = new Uint8Array(arrayBuffer);
    // for (var i = 0; i < binaryData.length; i++) {
    //     uint8Array[i] = binaryData.charCodeAt(i);
    // }
    //var arrayBuffer = new Uint8Array(blob).buffer;

    var contentType = 'image/jpeg';
    if (isMobile) {
      contentType = 'image/svg+xml';
    }
    // 创建 S3 上传参数
    objectKey = 'website/images/personalize/' + objectKey;
    var params = {
        Bucket: 'epicka-web',
        Key: objectKey,
        // Body: uint8Array,
        Body: blob,
        // ContentType: 'image/jpeg',
        ContentType: contentType,
        Tagging: 'public=yes'
    };

    // 使用 AWS SDK 上传图片到 S3
    var s3 = new AWS.S3();
    return new Promise((resolve, reject) => {
        s3.upload(params, function(err, data) {
            if (err) {
                reject(err);
            } else {
                resolve(data);
            }
        });
    });
}

window.uploadImageToS3 = uploadImageToS3;